import {
  textSmallBold,
  textSmallSemiBold,
} from '@hud/web-components/DesignSystem/Typography';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    h3 {
      color: var(--text-standard-primary);
      ${textSmallSemiBold}
    }

    .status {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: var(--space-100);
      span {
        ${textSmallBold}
        color: var(--text-success);
      }

      &.error {
        span,
        svg {
          color: var(--text-destructive);
        }
        div {
          display: flex;
          align-items: center;
          gap: var(--space-75);
        }
      }

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`;
